module.exports = __webpack_public_path__ + "img/thumb_08.3590d8bc.jpg";